export enum ECacheTag {
    // User
    user = 'cacheKeyUser',

    // Person
    person = 'cacheKeyPerson',

    // Taxonomy
    baseField = 'cacheKeyTaxonomyBaseField',
    reference = 'cacheKeyTaxonomyReference',
    referenceField = 'cacheKeyTaxonomyReferenceField',
    referenceItem = 'cacheKeyTaxonomyReferenceItem',

    //Contact
    contact = 'cacheKeyContact',

    // ContragentEntity
    contragent = 'cacheKeyContragent',

    // DealerEntity
    dealer = 'cacheKeyDealer',

    // OrderEntity
    order = 'cacheKeyOrder',
    orderAssemblyLocationList = 'cacheKeyOrderAssemblyLocationList',

    // Nomenclature
    nomenclatureType = 'cacheKeyNomenclatureType',
    nomenclatureTypeField = 'cacheKeyNomenclatureTypeField',
    nomenclatureTypeChild = 'cacheKeyNomenclatureTypeChild',
    nomenclaturePosition = 'cacheKeyNomenclaturePosition',

    // Prices
    priceType = 'cacheKeyPriceType',
    priceValue = 'cacheKeyPriceValue',

    // Production Areas
    area = 'cacheKeyArea',
    areaTypes = 'cacheKeyAreaTypes',

    // Profile
    profile = 'profile',

    // Profile Catalog
    profileCatalog = 'profileCatalog',

    // Settings
    settings = 'settings',

    // Announcement
    announcement = 'announcement',

    // Widget
    widgetGetList = 'cacheKeyWidgetGetList',
    widgetGetListDeleted = 'cacheKeyWidgetGetListDeleted',
    widgetView = 'cacheKeyWidgetView',
}
